import React from "react";
import { useSelector } from "react-redux";

import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Footer from "../../../../containers/Footer";

import PlayBtn from "../../../../assets/images/icons/play-icon.png";

import { useNavigate } from "react-router-dom";
import BackIcon from "../../../../assets/svg/BackIcon";
import {  casinoTabs } from "../../../../lib/data";

const Spribe = () => {
  const navigate = useNavigate();

  const { isAuth } = useSelector((state) => state.auth);
  return (
    <div>
      <div>
        <HeaderAfterLogin />
      </div>

      <main className="main">
        <div className="spribe-page">
          <div className="games-section">
            <div className="d-flex justify-content-between align-items-center PageHeading">
              <h2 className="">Spribe</h2>
              <div className="back-link" onClick={() => navigate(-1)}>
                Back <BackIcon />
              </div>
            </div>
            <ul className="mt-4">
              {Object.values(casinoTabs?.spribegames).map((item) => {
                return (
                  <li className="game-section">
                    <a href={isAuth ? item.redirectUrl : "/login"}>
                      <img src={item.imgUrl} />
                      <div className="casino_overlay">
                        <img src={PlayBtn} />
                      </div>
                      <p>{item.name}</p>
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </main>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default Spribe;
